<div *ngIf="form" [formGroup]="form" class="cord-label">
  <label class="label" for="{{ controlName }}">{{ label | translate }}</label>
  <div class="custom-control custom-switch">
    <input class="custom-control-input" type="checkbox" id="{{ controlName }}" [formControlName]="controlName"  [disabled]="isDisabled"/>
    <label class="custom-control-label" for="{{ controlName }}"></label>
  </div>
</div>
